/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

// No emiten un programa: arman una variable `mission` con los comandos del SDK del Tello
// separados por `|`, que parsea el puente del drone. Todo valor que no sea un literal
// numérico va envuelto en eval(): es el formato que espera el puente.

const valor = (code, separador) => {
  const literal = !Number.isNaN(Number(code));

  if (literal) return `${separador}${code}`;
  return `${separador}" + eval(${code}) + "`;
};

const distancia = (block, generator, name) => generator.valueToCode(block, name, generator.ORDER_NONE);

export const takeoff = (block, generator) => {
  generator.definitions_.a = 'var mission = ""';

  return '\nmission+="takeoff";';
};

export const land = () => '\nmission+="|land";';

// El `,null` es a propósito: el bloque no tiene campo de unidades, getFieldValue da null
// y así le llega también en prod al puente. No cambiarlo sin cambiar el bloque.
const comando = (nombre, campo) => (block, generator) => {
  const code = distancia(block, generator, campo);
  const units = block.getFieldValue('units');

  return `\nmission+="|${nombre}${valor(code, ',')},${units}";`;
};

export const set_speed = comando('speed', 'speed');
export const fly_forward = comando('forward', 'distance');
export const fly_backward = comando('back', 'distance');
export const fly_left = comando('left', 'distance');
export const fly_right = comando('right', 'distance');
export const fly_up = comando('up', 'distance');
export const fly_down = comando('down', 'distance');

const coordenadas = (nombre, campos) => (block, generator) => {
  const partes = campos.map((campo, i) => valor(distancia(block, generator, campo), i === 0 ? '' : ','));

  return `\nmission+="|${nombre},${partes.join('')}";`;
};

export const fly_xyz = coordenadas('go', ['xdistance', 'ydistance', 'zdistance', 'speed']);
export const curve = coordenadas('curve', [
  'x1distance', 'y1distance', 'z1distance',
  'x2distance', 'y2distance', 'z2distance',
  'speed',
]);

// Con el ángulo por eval() el string cierra con "": se replica para no mover el formato.
const giro = (nombre) => (block, generator) => {
  const code = distancia(block, generator, 'angle');
  if (Number.isNaN(Number(code))) return `\nmission+="|${nombre}," + eval(${code}) + "";`;

  return `\nmission+="|${nombre},${code}";`;
};

export const yaw_left = giro('ccw');
export const yaw_right = giro('cw');

export const flip_forward = () => '\nmission+="|flip,f";';
export const flip_backward = () => '\nmission+="|flip,b";';
export const flip_left = () => '\nmission+="|flip,l";';
export const flip_right = () => '\nmission+="|flip,r";';

// Saca las comillas del valor por si el slider las trae.
const campoNumerico = (nombre) => (block, generator) => [
  String(block.getFieldValue(nombre)).replace(/"/g, ''),
  generator.ORDER_ATOMIC,
];

export const slider_angle_360 = campoNumerico('angulo');
export const math_speed_min_max = campoNumerico('SLIDER');
export const math_speed_10_60 = campoNumerico('SLIDER');
export const math_distancia_min_max = campoNumerico('SLIDER');
export const math_distancia_500_500 = campoNumerico('SLIDER');

// El INFINITE_LOOP_TRAP del legacy no se porta: el set nunca lo activó.
export const controls_doWhile = (block, generator) => {
  let condition = (generator.valueToCode(block, 'WHILE', generator.ORDER_NONE) || '').replace(/&quot;/g, '"');
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  if (block.getFieldValue('MODE') === 'UNTIL') {
    if (!condition.match(/^\w+$/)) condition = `(${condition})`;
    condition = `!${condition}`;
  }

  return `\ndo{\n${branch}\n} while(${condition});\n`;
};

export const controls_repeat_educabot = (block, generator) => {
  const loopVar = generator.nameDB_
    ? generator.nameDB_.getDistinctName('count', 'VARIABLE')
    : 'count';
  const repeats = generator.valueToCode(block, 'TIMES', generator.ORDER_NONE);
  const branch = generator.statementToCode(block, 'DO').trim();

  return `\nfor(var ${loopVar} = 0; ${loopVar} < ${repeats}; ${loopVar}++){\n\t${branch}\n}`;
};
